/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#pay-button[_ngcontent-%COMP%]{background-color:#1c75bc}"];
export { styles as styles };
